import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'auditRelativeTime',
})
export class AuditRelativeTimePipe implements PipeTransform {
  transform(value: Date | string | number | null | undefined): string | null {
    if (!value) {
      return null;
    }

    return moment(value).fromNow();
  }
}
